module.exports = __webpack_public_path__ + "img/mg.f239e761.png";